<template>
    <div v-if="type === 'select'" loading :title="title" @click="click" class="select"></div>
    <transition v-else name="collapse">
        <div v-if="cells === undefined" loading :title="title" @click="click"></div>
        <td v-else :colspan="cells" loading>
            <div :title="title" @click="click"></div>
        </td>
    </transition>
</template>

<script>
export default {
	props: {
        cells: {
			type: Number,
			default: undefined
        },
        type: {
            type: String,
            default: undefined
        }
    },
    data(){
        return {
            title: 'Loading, Please Wait'
        }
    },
    methods: {
        click(){
            this.$store.dispatch('PAGE_ADD_NOTIFICATION', {message:this.title,theme:'info'});
        }
    }
}
</script>
